import { ref } from 'vue';

// module-scope — shared across all callers
const activeTranscriptConvId = ref(null);
const transcriptMessages = ref([]);

export function useTranscriptViewer() {
  const loadTranscript = (convId, messages) => {
    Console.log('[useTranscriptViewer] Loading transcript:', convId);
    activeTranscriptConvId.value = convId;
    transcriptMessages.value = messages;
  };

  const closeTranscript = () => {
    Console.log('[useTranscriptViewer] Closing transcript');
    activeTranscriptConvId.value = null;
    transcriptMessages.value = [];
  };

  return { activeTranscriptConvId, transcriptMessages, loadTranscript, closeTranscript };
}
